export const EXTERNAL_DATA_IMPORT_URL = "https://app.help-desk-migration.com/platforms/referral/helpdesk?utm_source=helpdesk-app&utm_medium=referral";
